import { render, staticRenderFns } from "./CommonAlertTwoBtn.vue?vue&type=template&id=d2dbca70&scoped=true&"
import script from "./CommonAlertTwoBtn.vue?vue&type=script&lang=js&"
export * from "./CommonAlertTwoBtn.vue?vue&type=script&lang=js&"
import style0 from "./CommonAlertTwoBtn.vue?vue&type=style&index=0&id=d2dbca70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dbca70",
  null
  
)

export default component.exports